import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Modal, ToggleButton, ToggleButtonGroup } from 'react-bootstrap-5';

import './styles.scss';

const QuokkaTemplateDefaultsModal = ({ iframeData, open, onClose, refreshQuokkaData }) => {
  const [propertyType, setPropertyType] = useState('sale');

  const handlePropertyTypeChange = (value) => {
    setPropertyType(value);
    refreshQuokkaData(value);
  };

  return (
    <Modal
      fullscreen
      show={open}
      onEnter={() => {
        setPropertyType('sale');
        refreshQuokkaData('sale');
      }}
      onHide={onClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Edit Template Default Options

          <div className="property-type-toggle d-flex align-items-center my-2">
            <p className="fs-large fw-light mb-0">Property Type:</p>
            <ToggleButtonGroup
              className="mx-2"
              name="pluginListingTypeSelect"
              type="radio"
              value={propertyType}
              onChange={handlePropertyTypeChange}
            >
              <ToggleButton
                id="plugin-sale"
                value="sale"
                variant="outline-primary"
              >
                Sale
              </ToggleButton>
              <ToggleButton
                id="plugin-lease"
                value="lease"
                variant="outline-primary"
              >
                Lease
              </ToggleButton>
            </ToggleButtonGroup>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body id="default-options-modal-editor">
        {
          iframeData ? (
            <iframe className="border w-100"
              ref={iframeData.ref}
              src={iframeData.src}
              style={{ height: '85vh' }}
            ></iframe>
          ) : (
            // Note: This should never happen
            <h3 className="d-flex justify-content-center align-items-center" style={{ height: '85vh' }}>
              Before editing options, please publish a property on the Website Editor.
            </h3>
          )
        }
      </Modal.Body>
    </Modal>
  );
};

QuokkaTemplateDefaultsModal.propTypes = {
  iframeData: PropTypes.shape({
    src: PropTypes.string.isRequired,
    ref: PropTypes.object.isRequired
  }),
  open: PropTypes.bool.isRequired,
  refreshQuokkaData: PropTypes.func,
  onClose: PropTypes.func
};

export default QuokkaTemplateDefaultsModal;
